(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    let productCardTouchStartX = 0;
  let productCardTouchStartY = 0;

  function toggleProductCardSecondaryImage(card) {
    card.classList.toggle('product-card--show-secondary');
    card.dispatchEvent(new CustomEvent('product-card:image-toggle', {
      bubbles: true,
    }));
  }

  function showProductCardSecondaryImage(card) {
    card.classList.add('product-card--show-secondary');
    card.dispatchEvent(new CustomEvent('product-card:image-toggle', {
      bubbles: true,
    }));
  }

  function shouldRevealProductCardSecondaryImageOnClick(card) {
    if (card.classList.contains('product-card--show-secondary')) return false;

    return window.matchMedia('(hover: none), (pointer: coarse)').matches;
  }

  document.addEventListener('click', event => {
    if (event.defaultPrevented) return;

    const image = event.target.closest('.product-card__primary-image, .product-card__secondary-image');
    const card = event.target.closest('[data-product-card]');

    if (
      image &&
      card?.querySelector('.product-card__secondary-image') &&
      shouldRevealProductCardSecondaryImageOnClick(card) &&
      !event.target.closest('[data-quick-view], [data-card-swatch], [data-card-size]')
    ) {
      event.preventDefault();
      showProductCardSecondaryImage(card);
    }
  });

  document.addEventListener('touchstart', event => {
    const thumbnail = event.target.closest('.product-card__thumbnail');

    if (!thumbnail || !event.touches.length) return;

    productCardTouchStartX = event.touches[0].clientX;
    productCardTouchStartY = event.touches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchend', event => {
    if (event.defaultPrevented) return;

    const thumbnail = event.target.closest('.product-card__thumbnail');
    const card = event.target.closest('[data-product-card]');

    if (!thumbnail || !card || !event.changedTouches.length) return;

    const touch = event.changedTouches[0];
    const deltaX = touch.clientX - productCardTouchStartX;
    const deltaY = touch.clientY - productCardTouchStartY;

    if (
      Math.abs(deltaX) <= 35 ||
      Math.abs(deltaX) <= Math.abs(deltaY) ||
      !card.querySelector('.product-card__secondary-image')
    ) {
      return;
    }

    event.preventDefault();
    toggleProductCardSecondaryImage(card);
  }, false);
  } catch(e) { console.error(e); }
})();

})();
